import { Flex, Heading, Image } from 'rebass';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import React from 'react';

import RatioBox from '../../../app/aspect-ratio-box';
// import addImageSvg from './assets/add-cover-photo.svg';
import Default_PreviewPhoto from '../../../stories/assets/Default_PreviewPhoto.png';

const CoverPreview = ({ previewSrc, handleDrop }) => {
  const { getRootProps, getInputProps } = useDropzone({ onDrop: handleDrop });
  return (
    <RatioBox
      ratio="1 / 2"
      borderRadius={8}
      mb={3}
      innerProps={{ sx: { display: 'flex', alignItems: 'stretch', width: '100%' } }}
    >
      {!previewSrc && (
        <Flex
          flex="1"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg="#EBEBEB"
          borderRadius="large"
          css={`
            max-height: 100%;
          `}
          {...getRootProps()}
        >
          <input {...getInputProps({ accept: 'image/*', multiple: false })} />
          <Image height={150} src={Default_PreviewPhoto} css="object-fit: cover; width: 100%;" />
        </Flex>
      )}
      {previewSrc && <Image borderRadius={8} src={previewSrc} alt="staged cover" sx={{ objectFit: 'cover' }} width="100%" />}
    </RatioBox>
  );
};

CoverPreview.propTypes = {
  previewSrc: PropTypes.string,
  handleDrop: PropTypes.func.isRequired,
};

CoverPreview.defaultProps = {
  previewSrc: '',
};

export default CoverPreview;
